module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-restaurants-booking u-fixed u-pos-tl u-zindex--6 u-flex u-flex-ai--center u-flex-jc--center u-fit",
    class: [_vm.bookRestaurantIsOpen ? 'is-visible' : 'is-hidden']
  }, [_c('div', {
    staticClass: "c-restaurants-booking__overlay u-absolute u-pos-tl u-fit u-bg--black-near u-opacity--90 u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._onClickOnOverlay()
      }
    }
  }, [(!_vm.$root.isTouch) ? _c('div', {
    staticClass: "c-restaurants-booking__overlay__close js-overlay-close u-absolute u-pos-tl u-inline-block"
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--bold t-text--xxxs u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_close)
    }
  })]) : (_vm.$root.isTouch) ? _c('div', {
    staticClass: "c-restaurants-booking__overlay__close-mobile u-absolute u-pos-tl u-flex u-flex-ai--center u-flex-jc--center u-fit-w"
  }, [_c('span', {
    staticClass: "t-ffamily--domaine t-fweight--bold t-text--xxxs u-uppercase u-color--white",
    domProps: {
      "innerHTML": _vm._s(_vm.content.label_close)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-restaurants-booking__container u-relative u-force-3d u-w6of10 u-w8of10@md",
    attrs: {
      "data-length": _vm.restaurants.length
    }
  }, _vm._l((_vm.restaurants), function(restaurant, index) {
    return (restaurant.the_fork_restaurant_id) ? _c('div', {
      staticClass: "c-restaurants-booking__restaurant u-absolute u-pos-tl u-fit u-bg--white",
      class: ['c-restaurants--booking--' + restaurant.slug, _vm.currentId === restaurant.the_fork_restaurant_id && _vm.bookRestaurantIsOpen ? 'is-visible' : 'is-hidden', !_vm.iframesLoaded.includes(restaurant.the_fork_restaurant_id) ? 'is-loading' : '']
    }, [_c('div', {
      staticClass: "c-restaurants-booking__restaurant__loader u-absolute u-pos-tl u-zindex--2 u-flex u-flex-ai--center u-flex-jc--center u-fit u-bg--gray-lighter"
    }, [_c('span', {
      staticClass: "t-fstyle--italic t-text--xxxs u-uppercase u-color--black-near",
      domProps: {
        "innerHTML": _vm._s(_vm.content.label_loading)
      }
    })]), _vm._v(" "), _c('iframe', {
      staticClass: "c-restaurants-booking__restaurant__iframe u-relative u-fit",
      attrs: {
        "src": 'https://module.lafourchette.com/' + _vm.lang + '/module/' + restaurant.the_fork_restaurant_id
      },
      on: {
        "load": function($event) {
          _vm._onLoadIframe(restaurant.the_fork_restaurant_id)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-restaurants-booking__restaurant__book-again u-absolute u-pos-bl u-flex u-flex-jc--center u-flex-ai--center u-fit-w u-pad-y-xxs u-pad-x-md u-bg--brand-red",
      class: [_vm.iframesBooked[_vm.currentId] && _vm.iframesBooked[_vm.currentId] > 1 ? 'is-hidden' : 'is-hidden']
    }, [_c('span', {
      staticClass: "t-text--xxxs t-fweight--bold u-color--white",
      domProps: {
        "innerHTML": _vm._s(_vm.content.label_book_again)
      }
    })])]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd2a55a"}!./src/scripts/components/app-restaurants-booking/template.html
// module id = 188
// module chunks = 0